import { render } from "./PropertiesList.vue?vue&type=template&id=4af8a1b4"
import script from "./PropertiesList.vue?vue&type=script&lang=js"
export * from "./PropertiesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__